module.exports = __webpack_public_path__ + "img/clipart2350691.ccf1f79f.png";